import { render, staticRenderFns } from "./DemoExerciseHintsModalComponent.vue?vue&type=template&id=fc5e60e0&scoped=true&"
import script from "./DemoExerciseHintsModalComponent.vue?vue&type=script&lang=js&"
export * from "./DemoExerciseHintsModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./DemoExerciseHintsModalComponent.vue?vue&type=style&index=0&id=fc5e60e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5e60e0",
  null
  
)

export default component.exports